import exportFromJSON from "export-from-json";

function formatDate(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero based
    const year = String(d.getFullYear()).substr(-2);
    return `${month}-${day}-${year}`;
   }

   export const excelParser = () => {
    function exportDataFromJSON(data, fileExportType) {
    if (!data) return;
    try {
     // Extract specific fields and format DateModified
     const extractedData = data.map(({ Title, ImageCount, StockNumber, Location, DateModified, WebsiteNotes,Price }) => ({
       Title,
       ImageCount,
       StockNumber,
       Price: Price === null ? "" : Price,
       Location,
       DateModified: formatDate(new Date(DateModified)),
       WebsiteNotes: WebsiteNotes === null ? "" : WebsiteNotes
     }));
   
     const fileName = formatDate(new Date())+"ImageUploaderExport";
     const exportType = exportFromJSON.types[fileExportType || "csv"];
     exportFromJSON({ data: extractedData, fileName, exportType });
    } catch (e) {
     throw new Error("Parsing failed!");
    }
    }
    return {
    exportDataFromJSON
    };
   };